import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";

const iPhoneWidth = 430
export default function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [searchParams, setSearchParams] = useSearchParams();
    const data = props.data


    return (
        <div className="relative h-full w-full flex flex-col items-center justify-start bg-[#999] p-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className="border-[4px] border-[#666] rounded-[16px] " style={{ width: iPhoneWidth, backgroundColor: "#F3F8FB" }}>
              
                <div className='w-full' style={{borderTopLeftRadius:16, borderTopRightRadius:16, overflow:'hidden'}}>
                    <img src={data.hero||data?.thumbnail} className='w-full' style={{objectFit:'cover', height:undefined,aspectRatio:data.heroAspectRatio||(430/242)}}/>
                </div>



                <div className='w-full p-[16px] flex-col flex' style={{gap:12}}>
                    <div className='text-[12px] text-black'>{data?.partnerName}</div>
                    <div className='text-[18px] text-[#6E604C] font-bold'>{data?.name}</div>
                    <div className='flex flex-row items-center' style={{gap:10}}>
                        <CreditSvg size={27}/>
                        <div className='text-[28px] text-[#0F737E] font-bold'>{data?.price}</div>
                        {data?.discountMessage&&<div className='text-[14px] text-[#6E604C] font-normal'>{data?.discountMessage}</div>}
                    </div>
                </div>


                <div className='text-[12px] text-[#6E604C] font-[300] px-[16px] my-[24px]'>商品詳情</div>
                <div className='flex flex-col w-full text-black'>
                    {data?.content?.map((c,ci)=>
                        c.type==='text'?<div key={ci} className='text-[#473F3A] text-[12px] px-[16px] mb-[16px]' style={{whiteSpace:'pre-line',textAlign:'justify'}}>{c?.content||''}</div>
                        :c.type==='image'?
                        <div key={ci} className='w-full flex flex-row' style={{justifyContent:c?.justifyContent||'center',width:'100%'}}>
                            <img src={c?.url} className='w-full mb-[16px]' style={{objectFit:'cover', height:undefined,aspectRatio:c.aspectRatio||(430/214),width:c.width||'100%'}}/>
                        </div>
                        :<div key={ci}/>
                    )}
                </div>
                


                <div className='w-full h-[250px]'/>





            </div>
        </div>
    )
}



const CreditSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={18}
        fill="none"
        {...props}
    >
        <path
            fill="url(#a)"
            d="M8.864.136A8.863 8.863 0 0 0 0 9a8.863 8.863 0 0 0 8.864 8.863V.136Z"
        />
        <path
            fill="#fff"
            stroke="#C7C7C7"
            strokeMiterlimit={10}
            strokeWidth={0.5}
            d="M15.75 9a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0Z"
        />
        <path
            fill="url(#b)"
            fillRule="evenodd"
            d="M8 5H5v2h3v6h2V7h3V5H8Z"
            clipRule="evenodd"
        />
        <defs>
            <linearGradient
                id="a"
                x1={0.364}
                x2={8.964}
                y1={7.665}
                y2={8.475}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={0.29} stopColor="#7D7649" />
                <stop offset={0.505} stopColor="#DDCFA2" />
                <stop offset={0.69} stopColor="#A59A87" />
                <stop offset={0.895} stopColor="#8C866B" />
            </linearGradient>
            <linearGradient
                id="b"
                x1={9}
                x2={9}
                y1={5}
                y2={13}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={0.14} stopColor="#8F896D" stopOpacity={0.96} />
                <stop offset={0.32} stopColor="#999274" stopOpacity={0.84} />
                <stop offset={0.53} stopColor="#C3B892" />
                <stop offset={0.76} stopColor="#BFB698" />
                <stop offset={1} stopColor="#B3AB93" />
            </linearGradient>
        </defs>
    </svg>
)